// components/AdminList/PdfList.jsx
import React from "react";

export default function PdfList({ title = "Файлы PDF", files = [], getLabel, getUrl, onOpen, onCopy, onDownload, onDelete }) {
    return (
        <div className="pdf-list">
            <div className="pdf-list__title">{`${title} (${files.length || 0})`}</div>
            {files.length ? (
                files.map((f, idx) => {
                    const label = getLabel ? getLabel(f) : String(f.filename || f.url || "document.pdf").split("/").pop();
                    const url = getUrl ? getUrl(f) : f.url || f.filename;
                    return (
                        <div className="pdf-item" key={idx}>
                            <div className="pdf-item__name" title={label}>{label}</div>
                            <div className="pdf-item__actions">
                                {onOpen ? <button className="btn btn--ghost" onClick={() => onOpen(url, f)}>Открыть</button> : null}
                                {onCopy ? <button className="btn btn--ghost" onClick={() => onCopy(url, f)}>Копировать</button> : null}
                                {onDownload ? <button className="btn btn--ghost" onClick={() => onDownload(url, f, label)}>Скачать</button> : null}
                                {onDelete ? <button className="btn btn--danger" onClick={() => onDelete(f)}>Удалить</button> : null}
                            </div>
                        </div>
                    );
                })
            ) : (
                <div className="pdf-empty">Нет файлов</div>
            )}
        </div>
    );
}
